const { REACT_APP_THERAPYLOG_URL } = process.env

export const getTherapyLogUrl = (path: string): string => {
  return `${REACT_APP_THERAPYLOG_URL}/${path}`.replace(/([^:]\/)\/+/g, '$1')
}

export default getTherapyLogUrl
